import axios from "axios";
import { logDev } from "../utils/logger.js";

/**
 * Fabrique une fonction de mise à jour de ligne pour le DataGrid des contacts.
 * - Vérifie que l’_id est bien un ObjectId Mongo
 * - Construit un payload enrichi pour l’API (enrichedRow)
 * - Construit une ligne finale pour l’UI (finalRow)
 * - Met à jour immédiatement le state local
 * - Envoie la mise à jour au backend
 */
export const createProcessRowUpdate = (groupeId, safePeriodes, setContacts, langue) => {
  return async (newRow, oldRow) => {
    // 1️⃣ Fusionner l’ancienne et la nouvelle ligne
    const mergedRow = { ...oldRow, ...newRow };
    logDev("[createProcessRowUpdate] mergedRow reçu (fusion old/new)", mergedRow);
    
    // 🚨 Vérification de l’_id Mongo
    if (!mergedRow._id || typeof mergedRow._id !== "string" || mergedRow._id.length !== 24) {
    logDev("[createProcessRowUpdate] saisie ignorée (pas d'_id Mongo)", mergedRow);
    return oldRow; // on annule la mise à jour côté front
  }

    // 2️⃣ Construire le payload pour l’API
    const periodesPayload = safePeriodes.map((p, i) => ({
      periodeId: p._id,
      /*valeur: Number(mergedRow[`periode${i + 1}`] || 0)*/
      valeur: Number(mergedRow[p._id] || 0)
    }));

    const enrichedRow = {
      ...mergedRow,
      groupe: groupeId,
      periodes: periodesPayload,
      combien: periodesPayload.reduce((sum, p) => sum + p.valeur, 0),
      langue
    };
    logDev("[createProcessRowUpdate] payload construit", enrichedRow);


    const finalRow = {
      ...mergedRow,
      periodes: periodesPayload, // 👈 c’est ça qui manque
      ...safePeriodes.reduce((acc, p) => {
      const vote = periodesPayload.find(v => v.periodeId === p._id);
      acc[p._id] = vote?.valeur || 0;
      return acc;
    }, {})
  };

  logDev("[createProcessRowUpdate] finalRow champs injectés", Object.keys(finalRow))

  logDev("[createProcessRowUpdate] finalRow (UI)", finalRow);

    // 4️⃣ Mise à jour immédiate du state local
    setContacts(prev => {
      const updated = prev.map(row =>
        row._id === mergedRow._id ? finalRow : row
      );
      logDev("[createProcessRowUpdate] state local mis à jour", updated);
      return [...updated];
    });

    // 5️⃣ Appel API PUT
    const url = `${process.env.REACT_APP_API}/contacts/${mergedRow._id}`;
    logDev("[createProcessRowUpdate] URL PUT", url);

    try {
      const res = await axios.put(url, enrichedRow);
      logDev("[createProcessRowUpdate] mise à jour réussie (backend)", res.data);

      // 6️⃣ Vérifier si tous les participants ont voté → déclencher notification
      /*try {
        await axios.post(`${process.env.REACT_APP_API}/send-survey-notification`, {
          groupeId,
          langue
      });
      logDev("[createProcessRowUpdate] Notification sondage envoyée si conditions remplies");
    } catch (err) {
      logDev("[createProcessRowUpdate] Erreur envoi notification sondage", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data
    });
  }*/


      // On fusionne la ligne finale (UI) avec les données renvoyées par l’API
      return { ...finalRow, ...res.data };
    } catch (err) {
      logDev("[createProcessRowUpdate] erreur mise à jour contact", { 
        status: err.response?.status, 
        data: err.response?.data, 
        message: err.message 
      });
      return oldRow; // rollback si erreur
    }
  };
};
